module.exports = "/_next/static/images/game-3-fingerprint-part-3-457fbd9fb4f5568d8fb749aa73879fb4.png";